export function formatFilterTags(filterTags: string[]): string {
    if (filterTags.length === 0) {
        return "Filter by";
    } else {
        const tag = filterTags[0];
        const count = filterTags.length;
        const text = count > 1 ? `${tag}, + ${count - 1} more` : tag;

        return `Filter by: ${text}`;
    }
}
